import moment, { Moment } from "moment";

/** A wrapper around moment() to make it easier to mock during unit tests. 
 *  I want to leave most of the moment() functions as is, but just mock this use case. */
export function GetCurrentTime(): Moment {
    return moment();
}